"use client";

import Image from "next/image";
import React from "react";
import { Heading, Link, Text } from "ui-components";

import { CLIENTS_SUCCESS_STORIES } from "@/src/constants/ClientsSuccessStories";

import { Slider } from "../slider/Slider";

const SUCCESS_STORIES_DATA = [
  {
    id: "rws",
    logoSrc:
      "https://res.cloudinary.com/dv6hrcluu/image/upload/f_auto,q_auto,w_120/corporate-solutions/css-rws-logo_s2n5eg.jpg",
    logoAlt: "RWS Logo",
    title:
      "Inclusive hiring helped RWS avoid over £250,000 in recruitment costs.",
    description:
      "Find out how RWS partnered with myGwork to build a diverse talent pipeline across global markets while cutting recruitment costs.",
    href: "https://mygwork.com/rws-and-mygwork-building-an-inclusive-talent-pipeline-and-reducing-recruitment-costs",
    bannerSrc:
      "https://res.cloudinary.com/dv6hrcluu/image/upload/f_auto,q_auto,w_515/corporate-solutions/css-rws-banner_jojt7n.jpg",
    bannerAlt: "RWS Banner",
  },
  {
    id: "lululemon",
    logoSrc:
      "https://res.cloudinary.com/dv6hrcluu/image/upload/f_auto,q_auto,w_120/corporate-solutions/css-lululemons-logo_mhscqu.jpg",
    logoAlt: "lululemon Logo",
    title:
      "How lululemon's inclusion focus generated 9,050 applications across four business units.",
    description:
      "Discover how lululemon scaled their inclusive hiring across four business units by tapping into myGwork's global LGBTQ+ talent network.",
    href: "https://mygwork.com/lululemon-and-mygwork-hiring-inclusively-at-scale-across-four-business-units",
    bannerSrc:
      "https://res.cloudinary.com/dv6hrcluu/image/upload/f_auto,q_auto,w_515/corporate-solutions/css-lululemons-banner_rviyu9.jpg",
    bannerAlt: "lululemon Team",
  },
  {
    id: "winston-taylor",
    logoSrc:
      "https://res.cloudinary.com/dv6hrcluu/image/upload/v1779282835/corporate-solutions/winston-taylor-logo_k7fvhj.png",
    logoAlt: "winston-taylor logo",
    title:
      "Winston Taylor reached 7,600+ diverse candidates through myGwork's WorkFair 2025.",
    description:
      "Find out how Winston Taylor partnered with myGwork's WorkFair to connect with the next generation of inclusive, ambitious talent.",
    href: "https://mygwork.com/winston-taylor-champions-lgbtq-early-careers-talent-at-workfair-2025",
    bannerSrc:
      "https://res.cloudinary.com/dv6hrcluu/image/upload/v1779282700/corporate-solutions/winston-taylor-banner_hd1cwj.png",
    bannerAlt: "Winston-taylor Team",
  },
];

const DEFAULT_IMAGE_FALLBACK =
  "https://res.cloudinary.com/dv6hrcluu/image/upload/v1709897247/web-app-images/my-g-work-small_nbamrj.svg";

export function ClientsSuccessStories({
  page = "default",
}: {
  page?: string;
}): JSX.Element {
  return (
    <div className="flex flex-col gap-y-10 lg:px-0 md:px-5">
      <Heading variant="h2" align="center">
        Clients Success Stories
      </Heading>
      <div>
        <Slider settings={CLIENTS_SUCCESS_STORIES}>
          {SUCCESS_STORIES_DATA.map((story) => (
            <div key={story.id} className="px-2 pb-2 h-full">
              <div
                className={`border border-primary rounded-[32px] grid grid-cols-1 ${
                  page === "corporate-solutions"
                    ? "md:grid-cols-1"
                    : "md:grid-cols-2"
                } bg-white p-8 h-full min-h-[400px]`}
              >
                <div className="flex flex-col justify-center gap-y-6">
                  <div className="mb-2">
                    <Image
                      className="object-contain"
                      src={story.logoSrc}
                      alt={story.logoAlt}
                      width={120}
                      height={120}
                      unoptimized
                      onError={(e) => {
                        e.currentTarget.src = DEFAULT_IMAGE_FALLBACK;
                        e.currentTarget.srcset = "";
                      }}
                    />
                  </div>
                  <Heading
                    variant="h3"
                    className="text-2xl leading-tight text-black"
                  >
                    {story.title}
                  </Heading>
                  <Text className="text-brand-body-primary text-base md:text-lg leading-relaxed">
                    {story.description}
                  </Text>
                  <div className="mt-2">
                    <Link
                      isAbsolute
                      href={story.href}
                      decoration
                      className="font-medium"
                    >
                      Read Success Story
                    </Link>
                  </div>
                </div>
                {page === "default" && (
                  <div className="hidden md:flex items-center justify-center h-full">
                    <Image
                      className="object-contain"
                      src={story.bannerSrc}
                      alt={story.bannerAlt}
                      width={515}
                      height={384}
                      unoptimized
                      onError={(e) => {
                        e.currentTarget.src = DEFAULT_IMAGE_FALLBACK;
                        e.currentTarget.srcset = "";
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
}
